export enum TipoExibicaoRetirada {
  ENDERECO = 1,
  OBSERVACAO = 2,
  NENHUM = 3,
}
